"use client";

import RequestCallbackForm from "@/components/forms/RequestCallbackForm";
import Section from "../components/Section";
import { Avatar, Box, Button, Dialog, Grid2, Typography } from "@repo/ui";
import { MailIcon, PhoneIcon } from "@spoctech/icons";
import { useState } from "react";
import { checkFirstString, hasData } from "@/lib/helpers";

type QueriesProps = {
  sectionInfo?: PageSections;
  data?: {
    heading?: string;
    subHeading?: string;
    buttonText?: string;
    buttonAction?: string;
    email?: string;
    phoneNumber?: string;
  };
};

export default function CommonRequestCallback({
  data,
  sectionInfo,
}: QueriesProps) {
  const [open, setOpen] = useState(false);

  if (!hasData(data)) return null;

  return (
    <Section
      className={`${sectionInfo?.sectionClass} bg-slate-100`}
      id={sectionInfo?.sectionId}
    >
      <Grid2 container spacing={5} align="center">
        <Grid2 size={{ sm: 12, md: 6 }}>
          <Box>
            <Typography variant="h2" gutterBottom>
              {data?.heading}
            </Typography>
            <Typography paragraph>{data?.subHeading}</Typography>
          </Box>
          <Button
            color="primary"
            variant="contained"
            label={data?.buttonText || "Request a callback"}
            onClick={() => setOpen(true)}
          />
        </Grid2>
        <Grid2
          size={{ sm: 12, md: 6 }}
          className="flex gap-5 sm:items-center sm:flex-row flex-col items-start"
        >
          <Box flex>
            <Avatar
              className="mr-4 !bg-white shadow-md !text-primary-main"
              size="large"
            >
              <MailIcon />
            </Avatar>
            <Box flex flexDirection="col" justifyContent="between">
              <Typography variant="subtitle1" className="font-semi-bold">
                Email us
              </Typography>
              <Typography
                variant="body2"
                className="gray-text"
                render={<a href={checkFirstString(data?.email || "#")} />}
              >
                {data?.email}
              </Typography>
            </Box>
          </Box>
          <Box flex>
            <Avatar
              className="mr-4 !bg-white shadow-md !text-primary-main"
              size="large"
            >
              <PhoneIcon />
            </Avatar>
            <Box flex flexDirection="col" justifyContent="between">
              <Typography variant="subtitle1" className="font-semi-bold">
                Call us
              </Typography>
              <Typography
                variant="body2"
                className="gray-text"
                render={<a href={checkFirstString(data?.phoneNumber || "#")} />}
              >
                {data?.phoneNumber}
              </Typography>
            </Box>
          </Box>
        </Grid2>
      </Grid2>
      {/* Request callback popup */}
      <Dialog
        open={open}
        onOpenChange={setOpen}
        maxWidth="md"
        title="Request Callback"
      >
        <RequestCallbackForm />
      </Dialog>
    </Section>
  );
}
